module.exports = __webpack_public_path__ + "static/img/H3W.8fd6295c.png";